import { Routes } from '@angular/router';
import { sessionGuard } from '../../../guards/session.guard';

export const quoteTemplateRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'quote-template-preview' },
    loadComponent: () => import('./quote-template-preview/quote-template-preview.page').then((m) => m.QuoteTemplatePreviewPage),
    path: ':quoteTemplateId/preview',
  },
];
